import {
    createLineMapper,
    createMutatorApi,
    joinLines,
    Mutation,
    Transformer,
} from "@buurman/commons";
import { FileApi } from "./FileApi";

export type Value = string;

export const initialValue: Value = "";

export const types = {
    SET: "SET",
    TRANSFORM: "TRANSFORM",
    APPEND: "APPEND",
    PREPEND: "PREPEND",
};

export const reducer = (
    value: Value = initialValue,
    { type, payload }: Mutation,
) => {
    switch (type) {
        default:
            return value;

        case types.SET:
            return payload;

        case types.APPEND:
            return `${value}${payload}`;

        case types.PREPEND:
            return `${payload}${value}`;

        case types.TRANSFORM:
            return payload(value);
    }
};

const FileMutator = (getApi: () => FileApi) => {
    const { createMutator, applyMutations } = createMutatorApi(getApi, reducer);

    return {
        applyMutations,
        mutations: {
            set: createMutator<string>(types.SET),
            transform: createMutator<Transformer<string>>(types.TRANSFORM),
            mapLines: createMutator(types.TRANSFORM, createLineMapper),
            setLines: createMutator(types.SET, joinLines),
            appendLines: createMutator(types.APPEND, joinLines),
            prependLines: createMutator(types.PREPEND, joinLines),
            append: createMutator<string>(types.APPEND),
            prepend: createMutator<string>(types.PREPEND),
        },
    };
};

export default FileMutator;
